export default {
  dashboard: {
    items: [
      {
        text: 'Dashboard',
        to: 'dashboard'
      }
    ]
  },
  // ---------------------------------------
  'projects.index': {
    items: [
      {
        text: 'Projects',
        to: 'projects.index'
      }
    ]
  },
  'projects.create': {
    parent: 'projects.index',
    items: [
      {
        text: 'Create project',
        to: 'projects.create'
      }
    ]
  },
  'projects.edit': {
    parent: 'projects.index',
    items: [
      {
        text: 'Edit project',
        to: 'projects.edit'
      }
    ]
  },
  'projects.show': {
    parent: 'projects.index',
    items: [
      {
        text: 'Detail',
        to: 'projects.show'
      }
    ]
  },
  // ---------------------------------------
  'my-workings.index': {
    items: [
      {
        text: 'My workings',
        to: 'my-workings.index'
      }
    ]
  },
  'my-workings.detail': {
    parent: 'my-workings.index',
    items: [
      {
        text: 'Detail',
        to: 'my-workings.detail'
      }
    ]
  },
  'my-workings.ask-support': {
    parent: 'my-workings.index',
    items: [
      {
        text: 'Ask for support',
        to: 'my-workings.ask-support'
      }
    ]
  },
  'my-workings.completing': {
    parent: 'my-workings.index',
    items: [
      {
        text: 'Completing',
        to: 'my-workings.completing'
      }
    ]
  },
  'project-processes.index': {
    items: [
      {
        text: 'Project process',
        to: 'project-processes.index'
      }
    ]
  },
  'project-processes.show': {
    items: [
      {
        text: 'Detail',
        to: 'project-processes.show'
      }
    ]
  },
  'task-evaluations.index': {
    items: [
      {
        text: 'Task evaluation',
        to: 'task-evaluations.index'
      }
    ]
  },
  'project-evaluations.index': {
    items: [
      {
        text: 'Project evaluation',
        to: 'project-evaluations.index'
      }
    ]
  },
  'my-points.index': {
    items: [
      {
        text: 'My points',
        to: 'my-points.index'
      }
    ]
  },
  'project-proposals.index': {
    items: [
      {
        text: 'Project Proposal',
        to: 'project-proposals.index'
      }
    ]
  },
  'tickets.index': {
    items: [
      {
        text: 'Tickets',
        to: 'tickets.index'
      }
    ]
  },
  'tickets.detail': {
    parent: 'tickets.index',
    items: [
      {
        text: 'Detail',
        to: 'tickets.detail'
      }
    ]
  },

  'reports.index': {
    items: [
      {
        text: 'Reports',
        to: 'reports.index'
      }
    ]
  },

  'users.index': {
    items: [
      {
        text: 'Users',
        to: 'users.index'
      }
    ]
  },

  'users.create': {
    parent: 'users.index',
    items: [
      {
        text: 'Create user',
        to: 'users.create'
      }
    ]
  },

  'users.edit': {
    parent: 'users.index',
    items: [
      {
        text: 'Edit user',
        to: 'users.edit'
      }
    ]
  },

  'reports.tasks': {
    items: [
      {
        text: 'Report tasks',
        to: 'reports.tasks'
      }
    ]
  },

  'reports.task-records': {
    items: [
      {
        text: 'Report task records',
        to: 'reports.task-records'
      }
    ]
  },

  'reports.points': {
    items: [
      {
        text: 'Report points',
        to: 'reports.points'
      }
    ]
  },

  'feedback.index': {
    items: [
      {
        text: 'Feedback',
        to: 'feedback.index'
      }
    ]
  },

  'feedback.show': {
    parent: 'feedback.index',
    items: [
      {
        text: 'Detail',
        to: 'feedback.show'
      }
    ]
  },

  'feedback.create': {
    parent: 'feedback.index',
    items: [
      {
        text: 'Create feedback',
        to: 'feedback.reate'
      }
    ]
  },

  'profile.index': {
    items: [
      {
        text: 'Your profile',
        to: 'profile.index'
      }
    ]
  }
}
